import { useContext, useEffect, useState } from "react";
import { AppContext } from "./AppContext";
import styles from './ChatFrame.module.css';

function ChatFrame() {
  const { state } = useContext(AppContext);
  // const windowHeightPX = window.innerHeight * (state.isLandscape ? .95 : 1);
  // const maxHeightPX = windowHeightPX * .8;
  // const { container, handle, isResizing } = useResizable({ direction: 'top', minSize: 300, maxSize: windowHeightPX });

  let tid = window.sessionStorage.getItem("edullaTid")
  // useEffect(() => {
  //   console.log(container.current.clientHeight)
  //   if (container.current.clientHeight > maxHeightPX) {
  //     container.current.style.height = `${windowHeightPX}px`
  //   }
  // }, [isResizing, maxHeightPX, windowHeightPX, container])
  // const iframeBase = "http://localhost:3000/index.html"
  const iframeBase = "https://bot.app.edulla.ai/index.html"
  const queryParam = `?tid=${tid}`;
  //const iframeBase = "http://localhost:3001"
  const [iframeSrc, setIframeSrc] = useState(iframeBase)
  // eslint-disable-next-line
  useEffect(() => {
    // eslint-disable-next-line
    setIframeSrc(iframeBase + state.lastLocation + queryParam)
    // eslint-disable-next-line
  }, []);
  return (
    // <div className={`${styles.chatFrameWrapper} ${(state.showChat ? styles.chatFrameWrapperShow : "")}`} ref={containe
    //* <span ref={handle} className={styles.chatFrameShrinkHandle}><HandleIcon color="white" size={45} /></span> */r}>
    <div className={`${styles.chatFrameWrapper} ${(state.showChat ? styles.chatFrameWrapperShow : "")}`} >
      <iframe className={`${styles.chatFrame}`} src={iframeSrc} id="edullaChatWidgetFrame" title="Chat"></iframe>
    </div >
  );
}

export default ChatFrame;
